import { Maybe, UsAePayErrorMessage } from '~/gql/__generated__/types';
export const getUsaEpayErrorDetails = (
  errorCode: string | null,
  usaEpayErrorMessages: Maybe<Maybe<UsAePayErrorMessage>[]> | undefined,
): UsAePayErrorMessage | undefined => {
  const code = errorCode?.trim();
  if (!code) return;
  if (
    usaEpayErrorMessages?.some(
      (item) => item?.errorCode?.includes(code) && item?.exclude,
    )
  ) {
    return undefined;
  }
  return (
    usaEpayErrorMessages?.find(
      (item) => item?.errorCode?.includes(code) && !item?.exclude,
    ) ||
    usaEpayErrorMessages?.find(
      (item) => item?.markAsDefault && !item?.exclude,
    ) ||
    undefined
  );
};
